import sampleClipMoments from '../mocks/sampleClipMoments'
import axios from "axios";
import {urlConfig} from "../config";
import firebaseapp from '../firebaseapp.js';
const firestoreDB = firebaseapp.firestore();

export default class UserService {

    static getSupportUsers(data){

        //let docRef = firestoreDB.collection("supportusers").doc();

        //return firestoreDB.collection("supportusers").get();
        const userManagementServiceInstance = axios.create({baseURL:`${urlConfig.bffUrl}`});

        return userManagementServiceInstance.post(`/ingestion/getTabsAllowedOnEmailFilter`, data);
    }

    static getUserData(parameterString){

        const userManagementServiceInstance = axios.create({baseURL: `${urlConfig.bffUrl}/usermanagement/`});

        return userManagementServiceInstance.get(`getUserData${parameterString}`);
    }

    static updateUserAttribute(body) {

        const userManagementServiceInstance = axios.create({baseURL: `${urlConfig.bffUrl}/usermanagement/`});

        return userManagementServiceInstance.patch("updateAttributeValue",body);
    }
}